export default {"src":"/_next/static/media/mxm.be067ec8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};